
namespace Matrix.Exceptions {
    export class ExceptionPolicyIgnoreColumns {
        static columnsKey = 'Exceptions.ExceptionPolicyIgnore';
    }
}